import React from "react";
import { cn } from "../../lib/utils";
import { FAQ_ITEMS } from "../../lib/constants";
import { SectionHeader } from "../ui/Divider";
import { Accordion } from "../ui/Accordion";

export function FAQ({ className }) {
  return (
    <section
      className={cn(
        "py-12 md:py-16 px-4",
        "bg-paper",
        className
      )}
    >
      <div className="max-w-3xl mx-auto">
        <SectionHeader
          title="Frequently Asked Questions"
          subtitle="Everything you need to know about subscribing to The Arabian-Nubian Brief."
        />

        <div className="scroll-animate">
          <Accordion items={FAQ_ITEMS} />
        </div>
      </div>
    </section>
  );
}
